const wowApp = require('angular').module('wowApp.shop');

wowApp.controller('PageMetadataController', ['$scope', '$location', 'PageMetadataService', '$state', '$injector', '$rootScope', require('./page-metadata-controller')]);
wowApp.service('PageMetadataService', ['Restangular', '$location', '$state', '$q', 'AtmService', require('./page-metadata-service')]);



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/pagemetadata/index.js
 **/